import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ImageCroppedEvent, OutputFormat } from "ngx-image-cropper";

@Component({
  selector: "app-cropper-dialog",
  templateUrl: "./cropper-dialog.component.html",
  styleUrls: ["./cropper-dialog.component.scss"]
})
export class CropperDialogComponent implements OnInit {
  aspectRatio = this.data.aspectRatio;
  imageChangedEvent: any = "";
  imageFile: File | null = null;
  croppedImage: any = "";

  constructor(
    public dialogRef: MatDialogRef<CropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get format(): OutputFormat {
    return (this.imageFile?.type?.split("/")[1] as OutputFormat) || "jpeg";
  }

  ngOnInit(): void {
    if (this.data.file) {
      this.imageFile = this.data.file;
    } else {
      this.imageChangedEvent = this.data.event;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  save() {
    this.dialogRef.close(this.croppedImage);
  }

  cancel() {
    this.dialogRef.close();
  }
}
